"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bleggio-superiore": {
    "2e395921": [{
      "hkey": "13232b23",
      "slug": "bleggio-superiore",
      "name": "Bleggio Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "8abbe30d": [{
      "hkey": "a6f967ba",
      "slug": "balbido-rango",
      "name": "Balbido-Rango",
      "primary": true,
      "skipSearch": false
    }],
    "9c98634a": [{
      "hkey": "7f751e78",
      "slug": "bivedo-larido-marazzone",
      "name": "Bivedo-Larido-Marazzone",
      "primary": true,
      "skipSearch": false
    }],
    "cornelle": [{
      "hkey": "13232b23",
      "slug": "bleggio-superiore",
      "name": "Bleggio Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3cd1a80": [{
      "hkey": "7f751e78",
      "slug": "bivedo-larido-marazzone",
      "name": "Bivedo-Larido-Marazzone",
      "primary": true,
      "skipSearch": false
    }],
    "larido": [{
      "hkey": "7f751e78",
      "slug": "bivedo-larido-marazzone",
      "name": "Bivedo-Larido-Marazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "marazzone": [{
      "hkey": "7f751e78",
      "slug": "bivedo-larido-marazzone",
      "name": "Bivedo-Larido-Marazzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bleggio-superiore"
    }],
    "rango-bivedo": [{
      "hkey": "a6f967ba",
      "slug": "balbido-rango",
      "name": "Balbido-Rango",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "39384647": [{
      "hkey": "c7b4a642",
      "slug": "madice",
      "name": "Madice",
      "primary": true,
      "skipSearch": false
    }],
    "madice-balbido": [{
      "hkey": "c7b4a642",
      "slug": "madice",
      "name": "Madice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;